import { Link } from 'react-router-dom';
import { Button, Input, InputGroup } from 'reactstrap';
import { Apply, CheckOut, ContinueShopping, Symbol, TotalPrice } from "../../../../constants";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import { getallCardTotal } from '../../../../utils/ecommerce';
import { routes } from '../../../../routers/routes';

// This component handles the actions buttons in the cart page, including applying a coupon code, checking out, and continuing shopping.
const Actions = () => {
  const { cart } = useAppSelector((state) => state.cartData);

  return (
    <>
      <tr>
        <td colSpan={4}>
          <InputGroup>
            <Input className="me-2" type="text" placeholder="Enter coupon code" />
            <Button color='primary' className="text-white">{Apply}</Button>
          </InputGroup>
        </td>
        <td className="total-amount">
          <h6 className="m-0 text-end" ><span className="f-w-600">{TotalPrice} :</span></h6>
        </td>
        <td><span>{Symbol}{getallCardTotal(cart)}</span></td>
      </tr>
      <tr>
        <td className="text-end" colSpan={5}><Link to={routes.ECommerce.Product} className="btn btn-secondary cart-btn-transform">{ContinueShopping}</Link></td>
        <td><Link className="btn btn-success cart-btn-transform" to={routes.ECommerce.Checkout}>{CheckOut}</Link></td>
      </tr>
    </>
  );
};

export default Actions;